<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'PRESET.CREATE_PRESET' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm" (click)="onCreate()" [disabled]="form.invalid">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="row">

                        <div class="col-3">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE.' | translate }}:</label>
                                <ng-select 
                                id="attribute_id" 
                                class="custom" 
                                clearAllText="{{ 'CLEAN' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="attribute_id" 
                                [multiple]="false" 
                                [items]="attributes">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-3">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_group_id"> {{ 'PRESET.GROUP_ATTRIBUTE' | translate }}:</label>
                                <ng-select 
                                id="attribute_group_id" 
                                class="custom" 
                                clearAllText="{{ 'CLEAN' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="attribute_group_id" 
                                [multiple]="false" 
                                [items]="attributeGroups">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-3">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_value_type"> {{ 'PRESET.TYPE_VALUE_ATTRIBUTES' | translate }}:</label>
                                <ng-select 
                                id="attribute_value_type" 
                                class="custom" 
                                clearAllText="{{ 'CLEAN' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="attribute_value_type" 
                                [multiple]="false" 
                                [items]="attributeValueTypes">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-3">
                            <div class="form-group">
                                <label class="filter-label" for="attr_present_type_id"> {{ 'TYPE_ATTRIBUTE' | translate }}:</label>
                                <ng-select 
                                id="attr_present_type_id" 
                                class="custom" 
                                clearAllText="{{ 'CLEAN' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="attr_present_type_id" 
                                [multiple]="false" 
                                [items]="attributePresentationTypes">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <label class="filter-label"> {{ 'SELECTORS' | translate }}</label>
                                <textarea class="form-control" type="text" formControlName="selectors"></textarea>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <label class="filter-label"> {{ 'ATTRIBUTE_FIELDS' | translate }}</label>
                                <textarea class="form-control" type="text" formControlName="front_field_attrs"></textarea>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <label class="filter-label"> {{ 'AUTOCOMLETE' | translate }}</label>
                                <textarea class="form-control" type="text" formControlName="autocomplete_func"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="checkboxes">
                        
                        <div class="row">

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="is_default">
                                    <label class="form-check-label"> {{ 'Default' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="mandatory">
                                    <label class="form-check-label"> {{ 'MANDATORY' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="visible">
                                    <label class="form-check-label"> {{ 'VISIBLE' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="readonly">
                                    <label class="form-check-label"> {{ 'READ_ONLY' | translate }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-group checkbox">
                                    <input class="form-check-input" type="checkbox" formControlName="translation">
                                    <label class="form-check-label"> {{ 'TRANSLATION' | translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>